<template>
  <li
    v-bind:class="{ active: sidebarActiveButton === 'style' }"
    @click="sidebarChangePanel('style');sidebarChangeActiveButton('style');canvasChangeView('preview')"
    :title="$t('general.labels.edition')">
    <i class="icon-kp-brush"></i>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    sidebarActiveButton: 'sidebarActiveButton',
  }),
  methods: mapActions([
    'sidebarChangePanel',
    'sidebarChangeActiveButton',
    'canvasChangeView',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Style.vue?2a3cd31e
 **/